<template>
  <div v-cloak>
    <div class="vx-card mb-4">
      <div class="vx-card__body card-body pt-4">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
            >
              <div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <div class="vx-row" v-if="showFilters">
          <div class="vx-col w-full">
            <form>
              <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <vs-input
                    class="inputx"
                    v-model="gridSearchData.PartyName"
                    :label="$t('PartyName')"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <label class="vs-input--label">{{ $t("PartyType") }}</label>
                  <div class="w-full">
                    <v-select
                      label="name"
                      :options="partyTypes"
                      v-model="gridSearchData.PartyType"
                      :reduce="(x) => x.value"
                      dir="rtl"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <vs-input
                    class="inputx"
                    v-model="gridSearchData.MinAmount"
                    :label="$t('MinPrice')"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <vs-input
                    class="inputx"
                    v-model="gridSearchData.MaxAmount"
                    :label="$t('MaxPrice')"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <label class="vs-input--label">{{
                    $t("ContractName")
                  }}</label>
                  <div class="w-full">
                    <v-select
                      label="title"
                      :options="allContracts"
                      v-model="gridSearchData.ContractId"
                      :reduce="(x) => x.id"
                      dir="rtl"
                    >
                    </v-select>
                  </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <label class="vs-select--label datepicker-lb">{{
                    $t("FromDate")
                  }}</label>
                  <date-picker
                    v-model="gridSearchData.MinCreateTime"
                    type="datetime"
                    format="jYYYY-jMM-jDD HH:mm:ss"
                    display-format="jYYYY-jMM-jDD HH:mm:ss"
                    class="date-picker"
                    :label="$t('FromDate')"
                    :clearable="true"
                  />
                </div>
                <div class="vx-col sm:w-1/4 w-full my-1">
                  <label class="vs-select--label datepicker-lb">{{
                    $t("ToDate")
                  }}</label>
                  <date-picker
                    v-model="gridSearchData.MaxCreateTime"
                    type="datetime"
                    format="jYYYY-jMM-jDD HH:mm:ss"
                    display-format="jYYYY-jMM-jDD HH:mm:ss"
                    class="date-picker"
                    :label="$t('ToDate')"
                    :clearable="true"
                  />
                </div>
                <div class="vx-col sm:w-1/2 w-full my-1">
                  <vs-input
                    class="inputx"
                    v-model="gridSearchData.Description"
                    :label="$t('Description')"
                  />
                </div>
                <div class="vx-col w-full sm:w-1/2 pt-6">
                  <div>
                    <vs-button
                      type="filled"
                      class="float-right"
                      @click.prevent="submitFilter()"
                      v-has-permission="permission"
                      >{{ $t("SubmitFilter") }}</vs-button
                    >
                    <vs-button
                      type="filled"
                      class="float-right mr-4"
                      id="reset-btn"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('PartyName'), sort: 'PartyName' },
                { title: $t('SalePersonName') },
                { title: $t('DraftOrderId'), sort: 'DraftOrderId' },
                { title: $t('PartyType'), sort: 'PartyType' },
                { title: $t('SiteOrderNumber'), sort: 'SiteOrderNumber' },
                { title: $t('ContractName'), sort: 'ContractName' },
                {
                  title: $t('TotalAmountForPayment'),
                  name: 'TotalAmountForPayment',
                },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Description') },
                { title: $t('DateSettlement') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 11%">
                  {{ row.draftOrderPartyInfoQueryDto.name }}
                </td>
                <td style="width: 8%">
                  {{
                    row.draftOrderSalePersonInfo
                      ? row.draftOrderSalePersonInfo.name
                      : "----"
                  }}
                </td>
                <td style="width: 8%">
                  {{ row.id }}
                </td>
                <td style="width: 9%">
                  <span
                    v-if="
                      row.draftOrderPartyInfoQueryDto.partyType == 'Individual'
                    "
                  >
                    {{ $t("Individual") }}
                  </span>
                  <span
                    v-if="row.draftOrderPartyInfoQueryDto.partyType == 'Legal'"
                  >
                    {{ $t("Legal") }}
                  </span>
                </td>
                <td style="width: 9%">
                  {{ "APO-" + row.basketId }}
                </td>
                <td style="width: 12%">
                  <span v-if="row.draftOrderContractQuery != null">
                    {{ row.draftOrderContractQuery.contractTitle }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td style="width: 12%">
                  {{ Number(row.totalAmountForPayment).toLocaleString() }} ریال
                </td>
                <td style="width: 8%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>

                <td style="width: 11%">
                  {{ row.basketDescription ? row.basketDescription : "---" }}
                </td>
                <td style="width: 7%">
                  <span v-if="row.settlementDate">
                    {{ row.settlementDate.split(" ")[0] }}<br />{{
                      row.settlementDate.split(" ")[1]
                    }}
                  </span>
                  <span v-else> --- </span>
                </td>
                <td style="width: 5%">
                  <router-link
                    :to="{
                      path: '/DraftOrder/Details/' + row.id,
                      query: {
                        saleType:
                          row.draftOrderContractQuery != null ? 'B2C' : 'B2B',
                      },
                    }"
                  >
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="mx-4 d-inline"
                      v-has-permission="permission2"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#reset-btn {
  margin-left: 1.5rem;
  background: #3ec9d6 !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "saleManagement_DraftOrders_Confirmed",

  computed: {
    ...mapGetters({
      allContracts: "sale/list",
    }),
  },
  data() {
    return {
      permission: "GetAllDraftOrder",
      permission2: "GetAllDraftOrderById",
      showFilters: false,
      gridDataSource: {
        type: "app",
        service: "Sales/api/DraftOrdersQuery",
      },
      gridSearchData: {
        PartyName: "",
        PartyType: "",
        ContractId: "",
        MinAmount: "",
        MaxAmount: "",
        MinCreateTime: "",
        MaxCreateTime: "",
        draftOrderState: "2",
      },
      partyTypes: [
        { name: "حقیقی", value: "Individual" },
        { name: "حقوقی", value: "Legal" },
      ],
    };
  },
  mounted() {
    this.fetchContract();
  },
  methods: {
    ...mapActions({
      fetchContract: "sale/fetchNoSkip",
    }),
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        PartyName: "",
        PartyType: "",
        ContractId: "",
        MinAmount: "",
        MaxAmount: "",
        MinCreateTime: "",
        MaxCreateTime: "",
        draftOrderState: "2",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
  components: {
    DataGrid,
    "v-select": vSelect,
    datePicker: VuePersianDatetimePicker,
  },
};
</script>
